import { useConvexAuth } from 'convex/react'

import { authClient } from '@/lib/auth-client'

// Convex auth lags the better-auth session right after a magic link (the
// one-time token is still being exchanged), so trust either before deciding.
export function useSignedIn(): 'loading' | 'in' | 'out' {
  const { isAuthenticated, isLoading } = useConvexAuth()
  const { data: session, isPending } = authClient.useSession()
  if (isAuthenticated || session) return 'in'
  return isLoading || isPending ? 'loading' : 'out'
}
